// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__MS9SB","controls":"styles_controls__2xyG7","charLimit":"styles_charLimit__3yfqq","input":"styles_input__1n43M","send":"styles_send__3Js4X"};